<template>
  <el-select
    v-model="cause"
    class="cause-select"
    @change="handleChange"
  >
    <el-option
      v-for="item in guestCauseOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>
<script>
export default {
  props: {
    guestCauseList: { // 訪客事由清單
      type: Array,
      default: () => []
    },
    defCause: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      cause: this.defCause,
      baseOptions: [{ value: 0, label: '請選擇' }]
    }
  },
  computed: {
    guestCauseOptions () {
      const newOptions = [...this.baseOptions]

      this.guestCauseList.forEach(item => {
        newOptions.push({
          value: item.Id,
          label: item.Name
        })
      })

      return newOptions
    }
  },
  watch: {
    defCause () {
      this.cause = this.defCause
    }
  },
  methods: {
    handleChange (value) {
      this.$emit('onChange', value)
    }
  }
}
</script>

<style lang="sass" scoped>
.cause-select
  width: 100%
</style>
